export default __webpack_public_path__ + "static/media/imageCategory1.8f988e10.png";